export const intentStyles = {
  base: 'intent-base',
  success: 'intent-success',
  warning: 'intent-warning',
  danger: 'intent-danger',
} as const;
